const PubDateFromOptions = {
	'NOW-1YEAR/DAY': '12 Months Ago',
	'NOW-6MONTH/DAY': '6 Months Ago',
	'NOW-3MONTH/DAY': '3 Months Ago',
	'NOW-1MONTH/DAY': '1 Month Ago',
	'NOW/DAY': 'Today',
	'NOW+1MONTH/DAY': 'In 1 Month',
	'NOW+2MONTH/DAY': 'In 2 Months',
	'NOW+3MONTH/DAY': 'In 3 Months',
	'NOW+6MONTH/DAY': 'In 6 Months',
};

export default PubDateFromOptions;
